import { render, staticRenderFns } from "./DashboardEnlaceNuevo.vue?vue&type=template&id=2159dbbb"
import script from "./DashboardEnlaceNuevo.vue?vue&type=script&lang=js"
export * from "./DashboardEnlaceNuevo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports